/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Menu, Modal } from "antd";
import React, { useState, useEffect } from "react";
import { ExclamationCircleOutlined, DeleteTwoTone, EditTwoTone } from "@ant-design/icons";
import { Loading } from "../../Common/components/Loading";
import CreateDocs from "../../PropertyComp/components/CreateDocs";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toolsAction } from "../state/actions";
import { EmptyData } from "../../Common/components/EmptyData";
import { PropertyHandlers } from "../../PropertyComp/state/actions";
import { transactionLaneDataHandle } from "../../Rtd/state/actions";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { ERTSAction } from "../../ErtsModel/state/action";
import axios from "axios";
import EditNameModal from "../../Common/components/EditNameModal";
import OtherDocsTable from "./OtherDocsTable";

const OtherDocs = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [otherDocsState, setOtherDocsState] = useState({
    createDocsModalOpen: false,
    isEditNameModalOpen: false,
    editDocDetails: {},
  });
  const { otherDocsData, otherDocsLoading, triggerOtherDocsDataFetch } = useSelector((state) => state.ToolReducers.CommonToolsReducer);
  const { OtherDocsAccess, CoxFormsAccess, checkIsMarkEibnerBrokerageLoading } = useSelector((state) => state.ERTSReducer);
  let { uploadedPdfDocSuccess } = useSelector((state) => state.PropertyReducer, shallowEqual);
  const { getUserDetailsData } = useSelector((state) => state.account);
  const [form] = Form.useForm();

  let unmounted = {
    value: false,
  };
  let sourceAxios = axios.CancelToken.source();
  useEffect(() => {
    dispatch(ERTSAction.checkIsMarkEibnerBrokerage({ unmounted, sourceAxios }));
    return () => {
      unmounted.value = true;
      sourceAxios.cancel("Cancelling in cleanup");
    };
  }, []);

  useEffect(() => {
    dispatch(toolsAction.getOtherDocsData());
  }, [triggerOtherDocsDataFetch, uploadedPdfDocSuccess]);

  const handleDeletePropertyDocs = (ele) => {
    Modal.confirm({
      title: "Are you sure you want to delete this document?",
      content: "Note: This action is irreversible. Deleting this document will permanently remove it from your account.",
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined style={{ color: "orange" }} />,
      onOk() {
        const payloadData = {
          documentId: ele?.documentId,
          source: "OTHER_DOCS",
        };
        dispatch(PropertyHandlers.deletePropertyContractDocs({ payloadData }));
      },
      onCancel() {},
    });
  };
  const handleCreateDocCancel = () => {
    setOtherDocsState({
      createDocsModalOpen: false,
    });
  };
  const handleOpenDoc = (eachDoc = {}) => {
    if (typeof eachDoc !== "object") return;
    if (eachDoc.isPdf || eachDoc.pdfLink) {
      window.open(eachDoc.pdfLink, "_blank");
    } else if (eachDoc.fileType === "IMAGE" || eachDoc.fileType === "PDF") {
      if (eachDoc?.fileUrl) {
        window.open(eachDoc?.fileUrl);
      }
    } else {
      let buildData = {
        builtForSection: "DOCUMENT",
        documentId: eachDoc._id,
        builtForId: getUserDetailsData?._id,
        key: getUserDetailsData?._id,
        contractType: eachDoc.contractType,
        contractId: eachDoc.contractId,
        openFor: "BUYER_AGENT",
        token: localStorage.getItem("userAuth"),
        signable: true,
        ...(eachDoc.RTDInitiator && { RTDInitiator: eachDoc.RTDInitiator }),
      };
      dispatch(transactionLaneDataHandle.generateUrlIdAndRedirect({ buildData, currentPath: location?.pathname }));
    }
  };

  const handleEditName = (item) => {
    setOtherDocsState({ ...otherDocsState, isEditNameModalOpen: true, editDocDetails: item });
  };

  const MenuItem = (props = {}) => {
    return (
      <Menu onClick={(event) => event?.domEvent?.stopPropagation()}>
        <Menu.Item key="renameDocument" onClick={() => handleEditName(props.item)}>
          <EditTwoTone
            style={{
              fontSize: 16,
            }}
          />
          <span style={{ color: "04396B" }}> Edit Name</span>
        </Menu.Item>
        <Menu.Item key="deleteDocument" onClick={() => handleDeletePropertyDocs(props.item)}>
          <DeleteTwoTone
            style={{
              fontSize: 16,
            }}
          />
          <span style={{ color: "04396B" }}> Delete document</span>
        </Menu.Item>
      </Menu>
    );
  };
  return (
    <>
      {otherDocsState?.isEditNameModalOpen && <EditNameModal nestedModalOpen={otherDocsState} setNestedModalOpen={setOtherDocsState} form={form} origin="toolsOtherDocs" />}
      <div style={{ height: "calc(100vh - 8rem)", overflowY: "auto", overflowX: "hidden" }}>
        {otherDocsState?.createDocsModalOpen && (
          <Modal
            width={"700px"}
            onCancel={() => {
              setOtherDocsState({ ...otherDocsState, createDocsModalOpen: false });
            }}
            open={otherDocsState?.createDocsModalOpen}
            footer={false}
            title={<div className="commonModalTitle">Create Other Docs</div>}
          >
            <div
              style={{
                height: "65vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "-10px",
              }}
            >
              <CreateDocs role={"NON_TRANSACTION_DOCS"} handleCreateDocCancel={handleCreateDocCancel} />
            </div>
          </Modal>
        )}

        {checkIsMarkEibnerBrokerageLoading || otherDocsLoading ? (
          <Loading />
        ) : (
          <div style={{ padding: "20px 0" }}>
            <Button
              type="primary"
              onClick={() => {
                setOtherDocsState({ ...otherDocsState, createDocsModalOpen: true });
              }}
              disabled={!(OtherDocsAccess || CoxFormsAccess)}
              style={{ marginBottom: "20px" }}
            >
              Create Other Docs
            </Button>

            {otherDocsData?.length ? (
              <OtherDocsTable otherDocsData={otherDocsData} handleOpenDoc={handleOpenDoc} MenuItem={MenuItem} origin={"TOOLS"} />
            ) : (
              <div style={{ marginTop: "200px" }}>
                <EmptyData />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default OtherDocs;
